import * as React from 'react';

import { Button, ButtonContainer, Grid, Link, Spacer, Typography } from '@emburse/ui-core';

import { SignUpWorkflowFooter } from '../SignUpWorkflowFooter';

import * as style from './SignUpEmburseCards.styl';

interface ISignUpEmburseCardsProps {
  onEmburseCardSelection: () => void;
  onBack: (navDirection: 'next' | 'back') => void;
  onSkip: (navDirection: 'next' | 'skip') => void;
}

export const SignUpEmburseCards: React.FC<ISignUpEmburseCardsProps> = ({ onEmburseCardSelection, onBack, onSkip }) => {
  return (
    <Grid container direction="column" spacing={1} sx={{ height: '100%', maxWidth: '754px' }} wrap="nowrap" className={style.global}>
      <Grid item className="layout">
        <Grid item className="flex jc-c">
          <img className="cardsLogo" src="/img/cards.svg" alt="logo" />
        </Grid>
        <Spacer size={32} />
        <Typography variant="h4">Expand controls with Emburse Cards</Typography>
        <Spacer size={8} />
        <Typography variant="subtitle1">
          Emburse Cards is a free, pre-funded cards solution that lets you limit how much employees can spend but also when and where
          purchases can be made.{' '}
          <Link href={'https://www.emburse.com/products/spend/why-spend/virtual-cards-for-business'} target="_blank" rel="noopener">
            Learn more
          </Link>
        </Typography>
        <Spacer size={32} />
        <Typography variant="subtitle1">Proactive Spend Controls</Typography>
        <Typography variant="body1">
          Issue unlimited physical or virtual corporate cards with highly customizable rules and limits to eliminate fraud, waste, and
          misuse.
        </Typography>
        <Spacer size={32} />
        <Typography variant="subtitle1">Simplified Subscription and Vendor Management</Typography>
        <Typography variant="body1">
          Instantly issue single-use or recurring virtual cards to securely manage subscription payments and vendor invoices.
        </Typography>
        <Spacer size={32} />
        <Typography variant="subtitle1">Turn Expenses into a Profit Center</Typography>
        <Typography variant="body1">
          Earn 1% cashback on every purchase made with Emburse Cards, from employee expenses to vendor payments.*
        </Typography>
        <Spacer size={32} />
        <Typography variant="subtitle1">Real-Time Visibility & Hands-Free Reconciliation</Typography>
        <Typography variant="body1">
          Emburse Card transactions appear within seconds of purchase, providing real-time visibility and reconciliation reminders. Automate
          the submission and review process and then effortlessly sync to your ERP with powerful integrations.
        </Typography>

        <Spacer size={32} />
        <ButtonContainer>
          <Button variant="outlined" onClick={() => onSkip('skip')} className="signup-emburse-cards-skip">
            Skip for now
          </Button>
          <Button onClick={onEmburseCardSelection} className="signup-emburse-cards-apply">
            Apply Now
          </Button>
        </ButtonContainer>
      </Grid>
      <Grid item xs>
        <Spacer size={4} />
      </Grid>
      <Grid item container xs alignContent="flex-end">
        <SignUpWorkflowFooter onBack={() => onBack('next')} showSupportLink={true} ariaLabel="emburse-cards" />
      </Grid>
    </Grid>
  );
};
